// extracted by mini-css-extract-plugin
export var legendIndicator = "_dt-1";
export var legendRight = "_dt-0";